<template>
  <div>
    <div class="row">
      <div class="col-12">
        <chart-filters></chart-filters>
      </div>
      <div class="col-12" v-if="filters.prisonGroupId && filters.before && filters.after">
        <b-tabs content-class="mt-3">
          <template #tabs-end>
            <prison-tab-name></prison-tab-name>
          </template>
          <b-tab title="Busiest Day" lazy>
            <div class="row">
              <div :class="compareMode ? 'col-6' : 'col-12'">
                <busiest-day key="b-1" :filters="filters"></busiest-day>
              </div>
              <div class="col-6" v-if="compareMode">
                <busiest-day key="b-2" :filters="compareFilters"></busiest-day>
              </div>
            </div>
          </b-tab>
          <b-tab title="Cancellations" lazy>
            <div class="row">
              <div :class="compareMode ? 'col-6' : 'col-12'">
                <cancellation-reasons :filters="filters"></cancellation-reasons>
              </div>
              <div class="col-6" v-if="compareMode">
                <cancellation-reasons :filters="compareFilters"></cancellation-reasons>
              </div>
            </div>
          </b-tab>
          <b-tab title="Resident Feedback" lazy>
            <div class="row">
              <div :class="compareMode ? 'col-6' : 'col-12'">
                <prisoner-feedback :filters="filters"></prisoner-feedback>
              </div>
              <div class="col-6" v-if="compareMode">
                <prisoner-feedback :filters="compareFilters"></prisoner-feedback>
              </div>
            </div>

          </b-tab>
          <b-tab title="User Feedback" lazy>
            <div class="row">
              <div :class="compareMode ? 'col-6' : 'col-12'">
                <visitor-feedback :filters="filters"></visitor-feedback>
              </div>
              <div class="col-6" v-if="compareMode">
                <visitor-feedback :filters="compareFilters"></visitor-feedback>
              </div>
            </div>
          </b-tab>
          <b-tab title="Termination Reasons" lazy>
            <div class="row">
              <div :class="compareMode ? 'col-6' : 'col-12'">
                <termination-reasons :filters="filters"></termination-reasons>
              </div>
              <div class="col-6" v-if="compareMode">
                <termination-reasons :filters="compareFilters"></termination-reasons>
              </div>
            </div>
          </b-tab>
          <b-tab title="Completed Calls" lazy>
            <div class="row">
              <div :class="compareMode ? 'col-6' : 'col-12'">
                <completed-calls-table :filters="filters"></completed-calls-table>
              </div>
              <div class="col-6" v-if="compareMode">
                <completed-calls-table :filters="compareFilters"></completed-calls-table>
              </div>
            </div>
          </b-tab>
          <b-tab title="Unique Calls" lazy>
            <div class="row">
              <unique-calls-table :filters="filters" class="col-12" />
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UniqueCallsTable from '@/components/tables/uniqueCalls/UniqueCallsTable.vue';
import ChartFilters from '../components/chartFilters/ChartFilters.vue';
import CancellationReasons from '../components/charts/calls/CancellationReasons.vue';
import PrisonerFeedback from '../components/charts/calls/PrisonerFeedback.vue';
import VisitorFeedback from '../components/charts/calls/VisitorFeedback.vue';
import TerminationReasons from '../components/charts/calls/TerminationReasons.vue';
import BusiestDay from '../components/charts/calls/BusiestDay.vue';
import CompletedCallsTable from '../components/tables/completedCalls/CompletedCallsTable.vue';
import PrisonTabName from '../components/other/PrisonTabName.vue';

export default {
  components: {
    ChartFilters,
    CancellationReasons,
    PrisonerFeedback,
    VisitorFeedback,
    TerminationReasons,
    BusiestDay,
    CompletedCallsTable,
    PrisonTabName,
    UniqueCallsTable,
  },
  computed: {
    ...mapState({
      filters: state => state.stats.filters,
      compareFilters: state => state.stats.compareFilters,
      compareMode: state => state.stats.compareMode,
    }),
  },
  methods: {},
}
</script>

<style>

</style>
